import { Registry } from '@lightningjs/sdk';

export function debounced(func, timeout = 500) {
  let timer;
  return (...args) => {
    Registry.clearTimeout(timer);
    timer = Registry.setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

/**
 * Example usage
 *
 * window.addEventListener('hashchange', debounce(() => console.log('bounce'), 1000))
 */
